import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-secure-payment',
  standalone: true,
  templateUrl: '../../assets/secure-payment.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSecurePaymentIcon {}
